import Button from 'devextreme-react/button';
import { showErrorMessage } from '../../../../utils/messages';
import { useState } from 'react';
import { useSaveCabinetInstallerScheduleMeasurmentScriptForm } from '../api/save-cabinetInstallerScheduleMeasurmentScriptForm';

const CabinetInstallerScheduleMeasurmentScriptForm: React.FC<{
    retailOrderID: number,
    retailOrderNumber: string,
    onClosePopup: () => void,
    onCheckboxChange: (checked: boolean) => void,
    onSubmit?: () => void
}> = ({ retailOrderID, retailOrderNumber, onClosePopup, onCheckboxChange, onSubmit }) => {

    const initialFormState = {
        closingCustomerDateTextbox: '',
        closingCustomerNameTextbox: '',
        closingThankYouCheckbox: false,
        discussPreparationBeforeCheckbox: false,
        discussPreparationContactCheckbox: false,
        discussPreparationDecisionMakerCheckbox: false,
        explainAfterYourCheckbox: false,
        explainAfterYourInstallationPurchaseCheckbox: false,
        explainHomeOutletCheckbox: false,
        explainHomeOutletOfferCheckbox: false,
        explainWeWillSendCheckbox: false,
        explainYouWillCheckbox: false,
        introductionCheckbox: false,
        introductionCompanyTextbox: '',
        introductionNameTextbox: '',
        notesTextbox: '',
        purposeGreatCheckbox: false,
        reiterateContactIfYouHaveCheckbox: false,
        reiterateEmailTextbox: '',
        reiteratePhoneNumberTextbox: '',
        scheduleAppointmentConfirmAddressTextbox: '',
        scheduleAppointmentFirstOptionTextbox: '',
        scheduleAppointmentPerfectCheckbox: false,
        scheduleAppointmentSecondOptionTextbox: '',
        scheduleAppointmentThirdOptionTextbox: '',
        scheduleAppointmentWeHaveCheckbox: false
    };

    const [formState, setFormState] = useState(initialFormState);

    const saveScheduleMeasurmentScriptForm = useSaveCabinetInstallerScheduleMeasurmentScriptForm(
        {
            formObject: {
                retailOrderID,
                retailOrderNo: retailOrderNumber,
                ...formState
            }
        },
        (result) => {
            onClosePopup();
            onCheckboxChange(true);
            if (onSubmit !== undefined) onSubmit!();
        },
        (error) => showErrorMessage(error)
    );

    const handleTextInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormState((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleReset = () => {
        setFormState(initialFormState);
    };

    return (
        <div>
            <div className='main-header'>
                <h1>Cabinets Call Script - Installer Schedule Measurement</h1>
            </div>
            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Greeting & Introduction</span></div>
                <div className='section-row'>
                    <input type="CheckBox"
                        checked={formState.introductionCheckbox} onChange={(e) => setFormState({ ...formState, introductionCheckbox: e.target.checked })} />
                    <span className='standard-margin-left-distance'>
                        “Hello, this is (Your Name)
                    </span>

                    <span className='standard-margin-left-distance'>
                        <input
                            type="text"
                            name="introductionNameTextbox"
                            value={formState.introductionNameTextbox}
                            onChange={handleTextInputChange}
                        />
                    </span>

                    <span className='standard-margin-left-distance'>
                        from <i>(Your Company)</i>
                    </span>
                    <span className='standard-margin-left-distance'>
                        <input
                            type="text"
                            name="introductionCompanyTextbox"
                            value={formState.introductionCompanyTextbox}
                            onChange={handleTextInputChange}
                        />
                    </span>
                    <label className='standard-margin-top-distance'>
                        I’m calling in regards to your cabinet measure order. How are you today?”
                    </label>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Purpose of the Call:</span></div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.purposeGreatCheckbox} onChange={(e) => setFormState({ ...formState, purposeGreatCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                            “Great! We are excited to get started on your installation for your new dream cabinets! First step is
                            taking measurements, I’d like to set up a time for us to come out and take precise measurements of
                            the areas for your new cabinets. What days’ work best for you?”
                        </span>
                    </label>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Schedule Appointment:</span></div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.scheduleAppointmentWeHaveCheckbox} onChange={(e) => setFormState({ ...formState, scheduleAppointmentWeHaveCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                            “We have availability on [insert two or three options)
                        </span>
                        <span className='standard-margin-left-distance'>
                            <input
                                type="text"
                                name="scheduleAppointmentFirstOptionTextbox"
                                value={formState.scheduleAppointmentFirstOptionTextbox}
                                onChange={handleTextInputChange}
                            />
                        </span>
                        <span className='standard-margin-left-distance'>
                            <input
                                type="text"
                                name="scheduleAppointmentSecondOptionTextbox"
                                value={formState.scheduleAppointmentSecondOptionTextbox}
                                onChange={handleTextInputChange}
                            />
                        </span>
                        <span className='standard-margin-left-distance'>
                            <input
                                type="text"
                                name="scheduleAppointmentThirdOptionTextbox"
                                value={formState.scheduleAppointmentThirdOptionTextbox}
                                onChange={handleTextInputChange}
                            />
                        </span>
                        <span className='standard-margin-left-distance'>
                            . Do any of these times work for you?”
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.scheduleAppointmentPerfectCheckbox} onChange={(e) => setFormState({ ...formState, scheduleAppointmentPerfectCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                            “Perfect! Just to confirm, we’ll be coming to your address at (confirm address) .
                            Is that correct?”
                        </span>
                        <span className='standard-margin-left-distance'>
                        <input
                                type="text"
                                name="scheduleAppointmentConfirmAddressTextbox"
                                value={formState.scheduleAppointmentConfirmAddressTextbox}
                                onChange={handleTextInputChange}
                            />
                        </span>
                    </label>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Discuss Preparation:</span></div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.discussPreparationBeforeCheckbox} onChange={(e) => setFormState({ ...formState, discussPreparationBeforeCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                            “Before our technician arrives, please ensure the area is clear of any personal items or furniture to
                            make the process smoother.”
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.discussPreparationDecisionMakerCheckbox} onChange={(e) => setFormState({ ...formState, discussPreparationDecisionMakerCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                            “A decision maker 18 years or older, capable of addressing any cabinet design elements which may
                            come up during the measure process must be present for the duration of the appointment.”
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.discussPreparationContactCheckbox} onChange={(e) => setFormState({ ...formState, discussPreparationContactCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                            “Please contact us immediately, at least 24 hours prior to your scheduled measure appointment, if
                            you need to reschedule.”
                        </span>
                    </label>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Explain Next Steps:</span></div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.explainYouWillCheckbox} onChange={(e) => setFormState({ ...formState, explainYouWillCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                            “You will receive emails and text from us throughout various steps of your project to keep you
                            informed.”
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.explainWeWillSendCheckbox} onChange={(e) => setFormState({ ...formState, explainWeWillSendCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                            “We will send the measurements to Home Outlet after your appointment and they will be in contact
                            with you shortly after to update your cabinet design.”
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.explainAfterYourCheckbox} onChange={(e) => setFormState({ ...formState, explainAfterYourCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                            “After your cabinet design is finalized, Home Outlet will send that to us to quote for installation.”
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.explainHomeOutletCheckbox} onChange={(e) => setFormState({ ...formState, explainHomeOutletCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                            “Home Outlet will again contact you with the final installation costs that include tear-out, installation,
                            and delivery. We offer additional services through Home Outlet to streamline your project and
                            protect your new cabinets. These services include: plumbing disconnect and reconnect, electrical
                            work, haul away, and Granite Gold Protection Plan. Please let us or Home Outlet know if you are
                            interested in adding on these services in your installation project.
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.explainAfterYourInstallationPurchaseCheckbox} onChange={(e) => setFormState({ ...formState, explainAfterYourInstallationPurchaseCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                            “After your cabinet installation purchase, we will contact you when the cabinets have shipped to
                            Home Outlet to schedule installation."
                        </span>
                    </label>
                </div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.explainHomeOutletOfferCheckbox} onChange={(e) => setFormState({ ...formState, explainHomeOutletOfferCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                            “Home Outlet also offers trending quartz, natural stone, and solid surface countertops to complete
                            your project. As Home Outlet’s service provider, we will ensure that your countertop installer is
                            informed for a seamless transition from your cabinet install to your countertop project."                        </span>
                    </label>
                </div>
            </div>

            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Reiterate Contact Information:</span></div>
                <div className='section-row'>
                    <label>
                        <input type="CheckBox"
                            checked={formState.reiterateContactIfYouHaveCheckbox} onChange={(e) => setFormState({ ...formState, reiterateContactIfYouHaveCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                        “If you have any questions before our appointment, feel free to reach out. You can contact us at
                        <i>(phone number)</i>
                        </span>
                        <span className='standard-margin-left-distance'>
                            <input
                                type="text"
                                name="reiteratePhoneNumberTextbox"
                                value={formState.reiteratePhoneNumberTextbox}
                                onChange={handleTextInputChange}
                            />
                        </span>
                        <span>
                        or <i>(email)</i>
                        </span>
                        <span className='standard-margin-left-distance'>
                            <input
                                type="text"
                                name="reiterateEmailTextbox"
                                value={formState.reiterateEmailTextbox}
                                onChange={handleTextInputChange}
                            />
                        </span>
                    </label>
                </div>
            </div>



            <div className='section-container'>
                <div className='sub-header-top-line'></div>
                <div className='sub-header'><span>Closing:</span></div>
                <div className='section-row'>

                <label>
                        <input type="CheckBox"
                            checked={formState.closingThankYouCheckbox} onChange={(e) => setFormState({ ...formState, closingThankYouCheckbox: e.target.checked })} />
                        <span className='standard-margin-left-distance'>
                        “Thank you for your time, (Customer’s Name)
                        </span>
                        <span className='standard-margin-left-distance'>
                            <input
                                type="text"
                                name="closingCustomerNameTextbox"
                                value={formState.closingCustomerNameTextbox}
                                onChange={handleTextInputChange}
                            />
                        </span>
                        <span>
                        . We look forward to
meeting you on (confirm date and time)
                        </span>
                        <span className='standard-margin-left-distance'>
                            <input
                                type="text"
                                name="closingCustomerDateTextbox"
                                value={formState.closingCustomerDateTextbox}
                                onChange={handleTextInputChange}
                            />
                        </span>
                    </label>


                    Notes:
                    <textarea
                        className='input-fullsize-large-height'
                        value={formState.notesTextbox}
                        onChange={handleTextInputChange}
                        placeholder="Note"
                        name='notesTextbox'
                        rows={5}
                        cols={40}
                    />
                </div>
            </div>

            <div className='button-container'>
                <Button
                    text="Reset"
                    className='reset-button'
                    type="danger"
                    onClick={(e) => {
                        handleReset()
                    }} >
                </Button>

                <Button
                    text="Save Changes"
                    className="save-button"
                    onClick={(e) => {
                        saveScheduleMeasurmentScriptForm.mutate();
                    }} >
                </Button>
            </div>
        </div >
    );
};

export default CabinetInstallerScheduleMeasurmentScriptForm;
